import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Topbar({ onMenuToggle }) {
  const [q, setQ] = useState('');
  const navigate = useNavigate();

  // 1. Initialize theme from localStorage or default to 'dark'
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  // 2. Update the HTML data-theme attribute whenever the theme changes
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  // 3. Toggle function
  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'dark' ? 'light' : 'dark'));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (q.trim()) navigate(`/search?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <header className="topbar">
      <button className="hamburger-btn" onClick={onMenuToggle}>☰</button>

      <form className="topbar-search" onSubmit={handleSearch}>
        <span className="search-icon">⌕</span>
        <input
          value={q}
          onChange={e => setQ(e.target.value)}
          placeholder="Quick search documents..."
        />
      </form>

      {/* 4. Update this container to use flexbox for horizontal alignment */}
      <div style={{ marginLeft: 'auto', display: 'flex', gap: '1rem', alignItems: 'center' }}>
        
        {/* 5. Add the Theme Toggle Button */}
        <button 
          className="btn-icon" 
          onClick={toggleTheme} 
          title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          style={{ fontSize: '1.2rem', padding: '0.25rem' }}
        >
          {theme === 'dark' ? '☀️' : '🌙'}
        </button>

        <button
          className="btn-primary-custom"
          onClick={() => navigate('/?new=1')}
          style={{ padding: '0.45rem 1rem', fontSize: '0.82rem' }}
        >
          + New Doc
        </button>
      </div>
    </header>
  );
}
